import { render } from "./AlgorithmComparison.vue?vue&type=template&id=562ae0b2&scoped=true"
import script from "./AlgorithmComparison.vue?vue&type=script&lang=js"
export * from "./AlgorithmComparison.vue?vue&type=script&lang=js"

import "./AlgorithmComparison.vue?vue&type=style&index=0&id=562ae0b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562ae0b2"]])

export default __exports__